module.exports = __webpack_public_path__ + "img/dayone.713c06c3.svg";